import distance from '@turf/distance';
import { Coord, point } from '@turf/helpers';
import { Station } from 'dataSources/Typicode/stations';
import { useCallback } from 'react';

export const useSortStationsByDistance = () => {
  return useCallback((countryStations: Station[], reference: Coord) => {
    return [...countryStations].sort((a, b) => {
      const coordinateA = a.coordinates;
      const coordinateB = b.coordinates;
      const distA = distance(reference, point([coordinateA.longitude, coordinateA.latitude]));
      const distB = distance(reference, point([coordinateB.longitude, coordinateB.latitude]));
      return distA - distB;
    });
  }, []);
};
